var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "hinava_random_uuid_88719597855539307635689003625517640746",
    d: "M8.493 11.399V3.172c0-.872.71-1.582 1.582-1.582h.528V.536h-.528c-.861 0-1.628.415-2.11 1.056C7.486.952 6.719.536 5.857.536H5.33V1.59h.527c.873 0 1.582.71 1.582 1.582v.553H1.77c-.873 0-1.583.71-1.583 1.582v4.219c0 .872.71 1.582 1.583 1.582h5.668v.291c0 .872-.71 1.582-1.582 1.582H5.33v1.055h.527c.862 0 1.628-.416 2.11-1.057.481.641 1.248 1.057 2.11 1.057h.527V12.98h-.528c-.872 0-1.582-.71-1.582-1.582zM1.77 10.053c-.291 0-.528-.237-.528-.527v-4.22c0-.29.237-.527.528-.527h5.668v5.274H1.77zm11.918-4.746v4.219c0 .872-.71 1.582-1.583 1.582H9.548v-1.055h2.557c.291 0 .528-.237.528-.527v-4.22c0-.29-.237-.527-.528-.527H9.548V3.725h2.557c.873 0 1.582.71 1.582 1.582z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.063 1.714)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "hinava_random_uuid_300070775932026813079325263762696616236",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hinava_random_uuid_88719597855539307635689003625517640746"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    fillRule: "nonzero",
    xlinkHref: "#hinava_random_uuid_88719597855539307635689003625517640746"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    mask: "url(#hinava_random_uuid_300070775932026813079325263762696616236)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 94.5,
    height: 43.5,
    rx: 8,
    transform: "translate(-38.25 -17.25)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.9dc20d35a5b9d2556b216402f11b0110.svg";
export { ForwardRef as ReactComponent };